import { authConfig } from "../apiConfig";

//  Get all classifications (without pagination)
export const get_classifications_without_pagination = async () => {
  try {
    const response = await authConfig.post(`getallClassification`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

//  Get classifications with pagination
export const get_classifications_with_pagination = async (data) => {
  try {
    const response = await authConfig.post(`getallClassification`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

//  Get classification by ID
export const get_classification_by_id = async (data) => {
  try {
    const response = await authConfig.post(`classificationViewByid`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

//  Create classification
export const classification_creation = async (data) => {
  try {
    const response = await authConfig.post(`createClassification`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

//  Update classification
export const classification_update = async (data) => {
  try {
    const response = await authConfig.post(`updateClassification`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

//  Delete classification
export const classification_deletion = async (data) => {
  try {
    const response = await authConfig.post(`deleteClassification`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response;
  } catch (error) {
    throw error;
  }
};
